
    import { Component, Mixins, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import moment from 'moment';
    import { GridConfig, GridFilters } from '@/types';
    import { ListItems, VGrid } from '@/types/Components';
    import { EmailsFilter } from '@/store/types';
    import { ResendEmailsPayload } from '@/store/emails';
    import LogbuchEmail from '@/types/LogbuchEmail';
    import LogbuchRow, { Priority } from '@/types/Logbuch';
    import GridResize from '@/mixins/GridResize';

    @Component({
        computed: {
            ...mapState('emails', ['filter', 'loaders']),
            ...mapGetters('authentication', ['isAllowed']),
        },
        methods: {
            ...mapActions('emails', ['resendEmails']),
        },
    })
    export default class EmailsLogbuch extends Mixins(Vue, GridResize) {
        public $refs!: {
            grid: VGrid<LogbuchRow>;
        };

        public filter!: EmailsFilter;
        public resendEmails!: (filter: ResendEmailsPayload) => void;

        public eintrag: LogbuchEmail | null = null;
        public zeitraumMenu = false;

        public readonly loglevel: ListItems<Priority> = [
            { text: 'Emergency', value: Priority.Emerg },
            { text: 'Alert', value: Priority.Alert },
            { text: 'Critical', value: Priority.Crit },
            { text: 'Error', value: Priority.Err },
            { text: 'Warning', value: Priority.Warn },
            { text: 'Notice', value: Priority.Notice },
            { text: 'Info', value: Priority.Info },
            { text: 'Debug', value: Priority.Debug },
        ];

        public onClickResend(): void {
            if (this.eintrag?.logbuch_email_seq) {
                this.resendEmails({ emails: [this.eintrag.logbuch_email_seq] });
            }
        }

        public get gridConfig(): GridConfig<LogbuchEmail> {
            return {
                id: 'logbuch-emails',
                title: 'Logbuch Emails',
                class: LogbuchEmail,
                remote: '/logs/emails/select',
                headers: [
                    {
                        value: 'zeitpunkt',
                        text: 'Zeitpunkt',
                        width: 175,
                    },
                    {
                        value: 'absender',
                        text: 'Absender',
                        width: 220,
                    },
                    {
                        value: 'empfaenger_email',
                        text: 'Empfänger',
                        width: 120,
                    },
                    {
                        value: 'actions',
                        text: '',
                        sortable: false,
                        width: 50,
                    },
                    {
                        value: 'betreff',
                        text: 'Betreff',
                    },
                ],
            };
        }

        public get filters(): GridFilters<LogbuchEmail> {
            const [minZeitraum, maxZeitraum] = [...this.filter.zeitraum].sort((a, b) => a.localeCompare(b));

            return [
                {
                    property: 'zeitpunkt',
                    operator: 'between',
                    type: 'date',
                    value: {
                        min: minZeitraum,
                        max: maxZeitraum,
                    },
                },
            ];
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get zeitraumLabel(): string {
            return this.filter.zeitraum.length
                ? [...this.filter.zeitraum].sort((a: string, b: string) => a.localeCompare(b)).map((date: string) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' - ')
                : '';
        }

        public onClickFiltern(): void {
            this.$refs.grid.load(true);
        }
    }
